import React, { useState } from 'react';
import github from '../Images/Technologies/github.svg';
import code from '../Images/Technologies/code.svg';

const ProjectsBox = ({ title, description, technologies, photo, link, githubLink }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const toggleDescription = () => setIsExpanded(!isExpanded);
    
    const truncatedDescription = description.length > 100
        ? `${description.substring(0, 100)}...`
        : description;

    const image = require(`../Images/Projects/${photo}.png`);
    return (
        <aside className="ProjectsBox"> 
            <h3>{title}</h3>
            <img src={image} alt={`${title} project`} id="porjectImg" />

            <aside className="technologies">
                {technologies.map((tech, index) => {
                    const techImage = require(`../Images/Technologies/${tech}.svg`);
                    return <img key={index} src={techImage} alt={`${tech} logo`} id="techImg" />;
                })}
            </aside>

            <p>
                {isExpanded ? description : truncatedDescription}
                {description.length > 100 && (
                    <button onClick={toggleDescription} className="readMoreButton">
                        {isExpanded ? 'Read Less' : 'Read More'}
                    </button>
                )}
            </p>

            <aside className="projectLinks">
                {link && (
                    <a className="websiteLink" href={link} target="_blank" rel="noreferrer">
                        <img src={code} alt="code logo" />
                    </a>
                )}
                <a className="github" href={githubLink} target="_blank" rel="noreferrer">
                    <img src={github} alt="github logo" />
                </a>
            </aside>
        </aside>
    );
};

export default ProjectsBox;
